import * as Immutable from "immutable";
import VisualizationConfig from "./VisualizationConfig";
export const DEFAULT_COLOR_PREFERENCE = "TREND_ONLY";
export default class NumberVisualizationConfig extends VisualizationConfig {
  constructor(trend, trendPreference, alignment = void 0, colorPreference = DEFAULT_COLOR_PREFERENCE) {
    super();
    this._value = { trend, trendPreference, alignment, colorPreference };
  }
  get trend() {
    return this._value.trend;
  }
  get trendPreference() {
    return this._value.trendPreference;
  }
  get alignment() {
    return this._value.alignment;
  }
  get colorPreference() {
    return this._value.colorPreference;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(trend = false, trendPreference = "NEUTRAL", alignment = void 0, colorPreference = DEFAULT_COLOR_PREFERENCE) {
    return new NumberVisualizationConfig(trend, trendPreference, alignment, colorPreference);
  }
  static empty() {
    return NumberVisualizationConfig.create(false, "NEUTRAL");
  }
  toJSON() {
    const { trend, trendPreference, alignment, colorPreference } = this._value;
    return {
      trend,
      trend_preference: trendPreference,
      alignment,
      color_preference: colorPreference
    };
  }
  equalsForSearch(other) {
    return other && "trend" in other && other.trend === this.trend;
  }
  static fromJSON(_type, value) {
    const { trend, trend_preference: trendPreference, alignment, color_preference: colorPreference } = value;
    return NumberVisualizationConfig.create(
      trend,
      trendPreference,
      alignment,
      colorPreference != null ? colorPreference : DEFAULT_COLOR_PREFERENCE
    );
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  trend(value) {
    return new Builder(this.value.set("trend", value));
  }
  trendPreference(value) {
    return new Builder(this.value.set("trendPreference", value));
  }
  alignment(value) {
    return new Builder(this.value.set("alignment", value));
  }
  colorPreference(value) {
    return new Builder(this.value.set("colorPreference", value));
  }
  build() {
    const { trend, trendPreference, alignment, colorPreference } = this.value.toObject();
    return new NumberVisualizationConfig(trend, trendPreference, alignment, colorPreference);
  }
}
